export const therapyModalityOptions = [
  {
    id: 'online',
    label: 'Terapia Online',
    brand: 'Beyond Consultas',
    description:
      'Consultas y terapias online guiadas por especialistas. Elige especialidad, revisa la reseña del profesional y solicita tu cita.',
    image: 'logo-beyond-consultas.png',
  },
  {
    id: 'presencial',
    label: 'Terapia Presencial',
    brand: 'Fundación Abrazando la Inclusión',
    description:
      'Atención presencial en sedes con oficina. Primero eliges el país y luego la sede disponible en Terapia.',
    image: 'logo-abrazando-inclusion.png',
  },
  {
    id: 'therappy',
    label: 'TherAppy+',
    brand: 'TherAppy+',
    description:
      'Terapias desde el celular guiadas por el avatar Lice. La aplicación aún está en diseño.',
    image: 'logo-therappy.png',
  },
];

/** Lista provisional de países. Más adelante podrá cargarse desde tabla administrable. */
export const agendaCountryOptions = [
  { id: 'pe', label: 'Perú' },
  { id: 'bo', label: 'Bolivia' },
  { id: 'br', label: 'Brasil' },
  { id: 'pa', label: 'Panamá' },
  { id: 've', label: 'Venezuela' },
  { id: 'co', label: 'Colombia' },
  { id: 'cr', label: 'Costa Rica' },
  { id: 'do', label: 'República Dominicana' },
  { id: 'us', label: 'Estados Unidos' },
  { id: 'ec', label: 'Ecuador' },
];

export const getTherapyModality = (id) =>
  therapyModalityOptions.find((item) => item.id === id) || null;

export const getAgendaCountry = (id) =>
  agendaCountryOptions.find((item) => item.id === id) || null;
